export enum AddressCategoryTypeEnum {
  HOME = "HOME",
  WORK = "WORK",
  OTHER = "OTHER"
}
export const AddressCategoryTypeEnumValues = [
  AddressCategoryTypeEnum.HOME,
  AddressCategoryTypeEnum.WORK,
  AddressCategoryTypeEnum.OTHER
]
